
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 16, 2018
 * For information or permission request, email info@aetonixsystems.com
 */

export default {
	title: "Body temperature",
	description: "glucose.manual_entry",
	type: "object",
	properties: {
		celsius: {
			type: "number",
			description: "bodytemperature.temperaturedescriptionCelsius",
			placeholder: "bodytemperature.messageCelsius",
			minimum: 1,
			maximum: 60
		},
		comment: {
			description: "bodytemperature.commenttitle",
			type: "string",
			multiline: true,
			placeholder: "bodytemperature.comment"
		}
	},
	required: ["celsius"]
};
